import Header from '../Header/Header'
import Link, { LinkProps } from '../Link/Link'

export interface SideNavigationProps {
  /**
   * Nav menu title
   */
  title: string
  /**
   * Array of links
   */
  items: {
    title: LinkProps
    links?: LinkProps[]
  }[]
}

export default function SideNavigation({ title, items }: SideNavigationProps) {
  return (
    <nav className="hidden p-6 lg:block">
      {/* overrideClassName drops Header's default h2 `type-display-2`; without it,
         Tailwind v4's alphabetical utility sort places `type-display-*` after
         `type-body-*` in the compiled CSS and the display size wins over the
         caller-supplied `type-body-1`. */}
      <Header className="type-body-1" as="h2" overrideClassName>
        {title}
      </Header>
      <ul>
        {items.map((item, index) => (
          <li key={index}>
            {/* Link `underline` prop pins the underline state, avoiding the same
               v4 sort issue (`no-underline` < `underline` alphabetically means
               `underline` wins when both classes coexist in one element). */}
            <Link
              className="[&]:type-body-3 [&]:visited:text-inherit [&]:hover:underline mt-4"
              href={item.title.href}
              inline
              underline={false}
              onClick={item.title.onClick}
            >
              {item.title.title}
            </Link>
            <ul className="ml-4">
              {item.links?.map((link, index) => (
                <li key={index}>
                  <Link
                    className="[&]:type-body-4 [&]:visited:text-inherit [&]:font-normal [&]:hover:underline mt-4"
                    href={link.href}
                    inline
                    underline={false}
                    onClick={link.onClick}
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  )
}
